module.exports = __webpack_public_path__ + "static/media/file-signature.be6ab708.svg";